import { useState, useEffect } from "react";
import { func, string, oneOf } from "prop-types";
import { useTranslation } from "react-i18next";
import { TextClearInput } from "@components";
import { Grid } from "@material-ui/core";

export const PriceModifierTitle = ({
  type,
  name,
  setName,
}) => {
  const { t } = useTranslation();
  
  const [ inputValue, setInputValue ] = useState(name);
  const [ focused, setFocused ] = useState(false);
  
  useEffect(() => {
    setInputValue(name);
  }, [ name ]);
  
  const handleFocus = () => {
    setFocused(true);
  }
  
  const handleSetName = () => {
    setFocused(false);
    if(!inputValue?.length)
      setInputValue(name);
    else
      setName(inputValue);
  }
  
  return (
    <Grid
      item container
      justifyContent="space-between"
      alignItems="center"
      wrap="nowrap"
    >
      <Grid
        item container
        alignItems="center"
        wrap="nowrap"
        className="w-full text-2xl mb-3"
        // style={{ maxWidth: 380 }}
      >
        <TextClearInput
          multiline
          value={inputValue}
          focused={focused}
          onFocus={handleFocus}
          onChange={setInputValue}
          onAccept={handleSetName}
          acceptOnClickAway
          confirmOnEnter
          error={!inputValue?.length}
          placeholder={t(`views.editor.dialogs.price_modifiers.${type}_name_placeholder`)}
          containerClass="name"
          maxLength={120}
        />
      </Grid>
    </Grid>
  );
};

PriceModifierTitle.propTypes = {
  type: oneOf(["discount", "overhead"]).isRequired,
  name: string.isRequired,
  setName: func.isRequired,
};